module.exports = __webpack_public_path__ + "img/Plan4-1.52234beb.jpg";